import messages from './messages';

export type VisitorModalMsgContext =
  | 'UserAccessValidityEditmodal'
  | 'UserListNewGuestmodal'
  | 'ApartmentUsersNewGuestmodal'
  | 'AAmodalNewGuestPIN';

export function getMessage(context: VisitorModalMsgContext, id: string) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  return messages[context][`${context}${id}`];
}

export function getIsDormakabaAlertConditionMet({
  hasDormakabaAccess,
  hasDormakabaDevice,
  isApartmentAdmin,
  isDormakabaEnabled,
  isUserInNoAccessGroup,
  shouldCheckApartmentDevices,
  shouldCheckDormakabaAccess,
}: {
  hasDormakabaAccess: boolean;
  hasDormakabaDevice: boolean;
  isApartmentAdmin: boolean;
  isDormakabaEnabled: boolean;
  isUserInNoAccessGroup: boolean;
  shouldCheckApartmentDevices: boolean;
  shouldCheckDormakabaAccess: boolean;
}): boolean {
  if (isUserInNoAccessGroup) {
    return isDormakabaEnabled;
  } else if (isApartmentAdmin || shouldCheckApartmentDevices) {
    return hasDormakabaDevice;
  } else if (shouldCheckDormakabaAccess) {
    return isDormakabaEnabled && hasDormakabaAccess;
  }
  return isDormakabaEnabled;
}

export function getPinValue({
  apartmentAdminPin,
  apartmentPinWithoutAccess,
  isApartment,
  isEdit,
  pinForUser,
  pinWithoutAccess,
}: {
  apartmentAdminPin: string | undefined;
  apartmentPinWithoutAccess: string | undefined;
  isApartment: boolean;
  isEdit: boolean;
  pinForUser: string | undefined;
  pinWithoutAccess: string | undefined;
}): string | undefined {
  if (isEdit) {
    return isApartment ? apartmentAdminPin : pinForUser;
  }
  return isApartment ? apartmentPinWithoutAccess : pinWithoutAccess;
}
